/* eslint-disable camelcase */
import uniqElementsBy from '~/utils/uniqElementsBy'
import isPresent from '~/utils/isPresent'
import isBlank from '~/utils/isBlank'

export default {
  data() {
    return {
      brand: null,
      device_id: null,
      case_device_id: null,
      caseTypeId: null,
    }
  },
  methods: {
    isPresent,
    isBlank,
    // returns an sorted array with brands
    sortBrands(brands) {
      const positions = [/iphone/i, /samsung/i, /motorola/i, /xiaomi/i, /lg/i]

      brands = [
        ...positions.map((brandPosition) => {
          return brands?.find((brand) => brand.match(brandPosition))
        }),
        ...brands,
      ].filter((notEmpty) => !!notEmpty)

      return uniqElementsBy(brands, (b1, b2) => b1 === b2)
    },
    setCaseDevice(caseDeviceId = null, surpriseCase = false) {
      if (this.isBlank(caseDeviceId) && !surpriseCase) return

      let device = null
      let caseTypeId = null

      const caseType = this.getCaseTypeByCaseDeviceId(caseDeviceId)
      caseTypeId = caseType?.id
      device = this.getDeviceByCaseTypeAndCaseDeviceId(
        caseType,
        caseDeviceId,
        surpriseCase
      )

      if (this.isPresent(device)) {
        this.brand = this.product.devices.find(
          (d) => d.id === device.device_id
        )?.brand
        this.device_id = device.device_id
        this.caseTypeId = caseTypeId
        this.case_device_id = device.case_device_id
      }
    },
    getCaseTypeByCaseDeviceId(caseDeviceId, surpriseCase = false) {
      let selectedCaseType = null
      for (const caseType of this.flatCaseTypes) {
        const d = this.getDeviceByCaseTypeAndCaseDeviceId(
          caseType,
          caseDeviceId,
          surpriseCase
        )
        if (d) {
          selectedCaseType = caseType
          break
        }
      }

      return selectedCaseType
    },
    getDeviceByCaseTypeAndCaseDeviceId(
      caseType,
      caseDeviceId,
      surpriseCase = false
    ) {
      return caseType?.devices?.find((d) =>
        surpriseCase
          ? d.device_id === this.device_id
          : d.case_device_id === caseDeviceId
      )
    },
  },
  computed: {
    devicesByIds() {
      let devices = this.product?.devices

      if (this.permittedDeviceIds) {
        devices = devices.filter((dv) =>
          this.permittedDeviceIds.split(',').includes(dv.id.toString())
        )
      }

      return devices
    },
    variants() {
      return this.product?.variants || []
    },
    variant() {
      return this.variants.find((v) => v.id === this.variant_id)
    },
    devices() {
      if (this.newDeviceSelectorLayout) {
        return this.devicesByIds
      }

      const filteredDevices = (this.devicesByIds ?? []).filter(
        (device) => device.brand === this.brand
      )

      return filteredDevices
    },
    outOfStock() {
      const isBoolean = (v) => typeof v === 'boolean'
      const isFalse = (v) => v === false
      const isOutOfStock = [
        // eslint-disable-next-line camelcase
        this.productStock?.product_in_stock,
        // eslint-disable-next-line camelcase
        this.productStock?.case_devices?.[this.caseDevice?.case_device_id],
        // eslint-disable-next-line camelcase
        this.variant?.in_stock,
      ]
        .filter(isBoolean)
        .some(isFalse)

      return isOutOfStock
    },
    device() {
      return this.devices.find((d) => d.id === this.device_id)
    },
    caseType() {
      const equalSelectedDevice = (ct) =>
        ct.devices.some((d) => d.case_device_id === this.case_device_id)

      let caseType = this.caseTypes.find(equalSelectedDevice)

      if (!caseType) {
        caseType = this.caseTypesFromGroup.find(equalSelectedDevice)
      }

      return caseType
    },
    caseDeviceMaterial() {
      if (this.device && this.caseType) {
        return this.caseType.code + '-' + this.device.code
      } else return null
    },
    material() {
      if (this.caseDeviceMaterial) {
        return this.caseDeviceMaterial
      } else if (this.variant_id) {
        return this.variants.find((v) => v.id === this.variant_id)?.material
      } else {
        return this.product?.material
      }
    },
    deviceBrands() {
      let brands = (this.devicesByIds || []).map((device) => device.brand)
      brands = brands.filter((opt) => opt !== 'Iphone')
      return this.sortBrands(brands)
    },
    caseTypes() {
      return (this.product?.case_types ?? []).filter((ct) =>
        ct.devices.map((d) => d.device_id).includes(Number(this.device_id))
      )
    },
    groupCaseTypesCovers() {
      const br = this.$store.state.storeCode === 'br'
      return (
        this.product?.case_types_groups
          ?.map((ctg) => {
            const ct = ctg.case_types.find((ct) =>
              ct.devices
                .map((d) => d.device_id)
                .includes(Number(this.device_id))
            )

            if (ct) {
              ctg.id = ct.id
              ctg.devices = ct.devices
              ctg.code = ct.code
              ctg.case_image = ctg.image_url
              ctg.name = br ? ctg.display_name_pt : ctg.display_name_en
              return ctg
            } else {
              return null
            }
          })
          ?.filter((ctg) => !!ctg) || []
      )
    },
    flatCaseTypes() {
      return [...this.product?.case_types, ...this.caseTypesFromGroup]
    },
    caseTypesFromGroup() {
      return (
        this.product?.case_types_groups?.reduce(
          (acc, curr) => acc.concat(curr.case_types),
          []
        ) ?? []
      )
    },
  },
}
